import React from 'react';
import ColorRibbonBtn from 'containers/Ribbon/ShelvesRibbon/ColorRibbonBtn';
import {
  selectDoorsAction,
  selectPanesAction,
} from 'containers/Ribbon/ShelvesRibbon/actions';
import { Position, PositionAngle } from 'lib/modelBuilder/constants';
import { selectionDrawersAction } from 'containers/DrawersPanel/actions';
import { selectionHandlesAction } from 'containers/HandlesPanel/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  ColorPreviewItem,
  makeSelectCommonDoorColors,
  makeSelectCommonDrawersColors,
} from 'containers/PanesPanel/selectors';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Ribbon/ShelvesRibbon/types';
import {
  makeSelectHaveOneDoor,
  makeSelectHaveOneDrawer,
} from 'containers/Ribbon/ShelvesRibbon/selectors';
import {
  makeSelectAllDrawersSelectionArray,
  makeSelectFullDrawersSelection,
  makeSelectIsSameDrawersNumberInShelvesSelected,
} from 'containers/DrawersPanel/selectors';

import { useTranslation } from 'react-i18next';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import { makeSelectCommonColorsIS } from 'containers/IntermediateShelfPanel/selectors';
import {
  makeSelectCanAddIs,
  makeSelectCommonHandlerColors,
  makeSelectCommonPaneColors,
  makeSelectCommonPlateColors,
} from './selectors';
import { ActivePanel } from '../../../Configurator/constants/general';

interface StateProps {
  haveOneDrawer: boolean;
  haveOneDoor: boolean;
  doorColors: ColorPreviewItem[] | undefined;
  drawerColors: ColorPreviewItem[] | undefined;
  handlerColors: ColorPreviewItem[] | undefined;
  intermediateShelfColors: ColorPreviewItem[] | undefined;
  leftPaneColors: ColorPreviewItem | undefined;
  rightPaneColors: ColorPreviewItem | undefined;
  backpaneColors: ColorPreviewItem | undefined;
  plateColors: ColorPreviewItem | undefined;
  sameNumberDrawersShelvesInSelection: boolean;
  isAllSelectionDrawers: boolean;
  drawerSelection: number[] | null;
  canAddIs: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  haveOneDrawer: makeSelectHaveOneDrawer(),
  haveOneDoor: makeSelectHaveOneDoor(),
  doorColors: makeSelectCommonDoorColors(),
  drawerColors: makeSelectCommonDrawersColors(),
  handlerColors: makeSelectCommonHandlerColors(),
  intermediateShelfColors: makeSelectCommonColorsIS(),
  backpaneColors: makeSelectCommonPaneColors(Position.Back),
  leftPaneColors: makeSelectCommonPaneColors(Position.Left),
  rightPaneColors: makeSelectCommonPaneColors(Position.Right),
  plateColors: makeSelectCommonPlateColors(),
  isAllSelectionDrawers: makeSelectFullDrawersSelection(),
  sameNumberDrawersShelvesInSelection: makeSelectIsSameDrawersNumberInShelvesSelected(),
  drawerSelection: makeSelectAllDrawersSelectionArray(),
  canAddIs: makeSelectCanAddIs(),
});

const ColorSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    haveOneDrawer,
    haveOneDoor,
    doorColors,
    drawerColors,
    handlerColors,
    intermediateShelfColors,
    sameNumberDrawersShelvesInSelection,
    isAllSelectionDrawers,
    drawerSelection,
    backpaneColors,
    leftPaneColors,
    rightPaneColors,
    plateColors,
    canAddIs,
  } = useSelector(stateSelector);

  return (
    <>
      <div className="flex  flex-wrap max-w-sm">
        {haveOneDoor && (
          <ColorRibbonBtn
            title={t('Doors')}
            manageClick={() => {
              // TODO: if four doors, select all doors
              dispatch(
                selectDoorsAction([
                  PositionAngle.FrontRight,
                  PositionAngle.FrontLeft,
                ]),
              );
              // dispatch(displayColorsPanel(true));
              dispatch(setColorsPanelAction(ActivePanel.panes));
            }}
            colors={doorColors}
          />
        )}
        {haveOneDrawer && (
          <ColorRibbonBtn
            title={t('Drawers')}
            manageClick={() => {
              // Select the drawers
              if (sameNumberDrawersShelvesInSelection && drawerSelection) {
                dispatch(selectionDrawersAction(drawerSelection));
              } else {
                dispatch(selectionDrawersAction('All'));
              }
              dispatch(setColorsPanelAction(ActivePanel.drawers));
            }}
            colors={drawerColors}
            colorDispositionColumn
          />
        )}
        {/*        {(haveOneDoor || haveOneDrawer) && (
          <ColorRibbonBtn
            title={t('Handlers')}
            manageClick={() => {
              dispatch(selectionHandlesAction([Position.Left, Position.Right]));
              dispatch(setColorsPanelAction(ActivePanel.handles));
            }}
            colors={handlerColors}
          />
        )}*/}
        <ColorRibbonBtn
          title={t('Plates')}
          manageClick={() => {
            dispatch(setColorsPanelAction(ActivePanel.plates));
          }}
          colors={[plateColors]}
        />

        <ColorRibbonBtn
          title={t('Sidepanes')}
          manageClick={() => {
            dispatch(selectPanesAction([Position.Right, Position.Left]));
            dispatch(setColorsPanelAction(ActivePanel.panes));
          }}
          colors={[leftPaneColors, rightPaneColors]}
        />
        <ColorRibbonBtn
          title={t('Backpane')}
          manageClick={() => {
            dispatch(selectPanesAction([Position.Back]));
            dispatch(setColorsPanelAction(ActivePanel.panes));
          }}
          colors={[backpaneColors]}
        />

        {/*{!isAllSelectionDrawers && canAddIs && (
          <ColorRibbonBtn
            title={t('short.Intermediates shelves')}
            manageClick={() => {
              dispatch(setColorsPanelAction(ActivePanel.IntermediateShelf));
            }}
            disabledMessage={t(
              'The selected shelves must have the same number of intermediate shelves',
            )}
            colors={intermediateShelfColors?.reverse()}
            colorDispositionColumn
          />
        )}*/}
      </div>
    </>
  );
};

export default ColorSection;
